import React from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner.jpg";
import cubes from "../../assets/images/intro/cubes.jpg";
import Cta from "../../components/common/Cta";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

const AluminiumCubes = () => {
    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
    return (
        <div>
            <Helmet>
                <title>Aluminium Cubes</title>
            </Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title={"Aluminium Cubes"}
            />
            <div class="hero-layout container ptb-50">
                <div>
                    <div class="hero-badge">
                        <span></span>
                        In Stock — Ready for Bulk Dispatch
                    </div>
                    <h1>High-Purity<em>Aluminium Cubes </em>for Industry</h1>
                    <p class="hero-desc">
                        Manufactured from carefully recycled aluminium scrap through advanced melting and casting processes. Our cubes deliver consistent alloy composition, minimal impurities, and reliable mechanical performance for demanding industrial and manufacturing applications.</p>
                    <div class="hero-tags" aria-label="Product highlights">
                        <span class="tag">ADC12 Grade</span>
                        <span class="tag">A380 Grade</span>
                        <span class="tag">LM6 Grade</span>
                        <span class="tag">LM24 Grade</span>
                        <span class="tag">Custom Alloys</span>
                        <span class="tag">Bulk Supply</span>
                        <span class="tag">Pan-India Delivery</span>
                    </div>
                    <div class="hero-actions">
                        <a href="/contact" class="btn-primary">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>
                            Request a Quote
                        </a>
                        <a href="#specifications" class="btn-secondary">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14,2 14,8 20,8" /></svg>
                            View Datasheet
                        </a>
                    </div>
                </div>

                <div class="hero-visual">
                    <div class="product-visual-card">
                        <div class="visual-img">
                            {/* <svg width="320" height="200" viewBox="0 0 320 200" xmlns="http://www.w3.org/2000/svg">
                                <defs>
                                    <linearGradient id="ig1" x1="0" y1="0" x2="1" y2="1">
                                        <stop offset="0%" stop-color="#c8d4e8" />
                                        <stop offset="100%" stop-color="#8090aa" />
                                    </linearGradient>
                                    <linearGradient id="ig2" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stop-color="#aabace" />
                                        <stop offset="100%" stop-color="#6070880" />
                                    </linearGradient>
                                </defs>
                                <g opacity="0.9">
                                    <rect x="60" y="60" width="90" height="44" rx="5" fill="#607088" opacity="0.5" />
                                    <rect x="170" y="60" width="90" height="44" rx="5" fill="#607088" opacity="0.5" />

                                    <ellipse cx="105" cy="60" rx="45" ry="9" fill="#8090a8" opacity="0.5" />
                                    <ellipse cx="215" cy="60" rx="45" ry="9" fill="#8090a8" opacity="0.5" />

                                    <rect x="45" y="90" width="100" height="48" rx="5" fill="url(#ig1)" />
                                    <rect x="175" y="90" width="100" height="48" rx="5" fill="url(#ig1)" />
                                    <ellipse cx="95" cy="90" rx="50" ry="10" fill="#c8d4e8" />
                                    <ellipse cx="225" cy="90" rx="50" ry="10" fill="#c8d4e8" />

                                    <line x1="60" y1="110" x2="130" y2="110" stroke="rgba(255,255,255,0.2)" stroke-width="1" />
                                    <line x1="190" y1="110" x2="260" y2="110" stroke="rgba(255,255,255,0.2)" stroke-width="1" />

                                    <rect x="30" y="124" width="120" height="54" rx="6" fill="url(#ig2)" />
                                    <rect x="168" y="124" width="120" height="54" rx="6" fill="url(#ig2)" />
                                    <ellipse cx="90" cy="124" rx="60" ry="12" fill="#d4e0f0" />
                                    <ellipse cx="228" cy="124" rx="60" ry="12" fill="#d4e0f0" />
                                    <text x="90" y="156" text-anchor="middle" font-size="10" fill="rgba(255,255,255,0.4)" font-family="sans-serif" letter-spacing="2">ADC-12</text>
                                    <text x="228" y="156" text-anchor="middle" font-size="10" fill="rgba(255,255,255,0.4)" font-family="sans-serif" letter-spacing="2">A-380</text>
                                </g>
                                <circle cx="160" cy="40" r="50" fill="rgba(224,122,47,0.12)" />
                                <text x="160" y="24" text-anchor="middle" font-size="11" fill="rgba(224,122,47,0.6)" font-family="sans-serif" letter-spacing="3">ROLIOX ALLOYS</text>
                            </svg> */}
                            <img src={cubes} />
                        </div>

                        <div class="visual-stats">
                            <div class="stat-item">
                                <div class="stat-val"><em>As per requirement</em></div>
                                <div class="stat-label">Aluminium Purity</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-val"><em>As per requirement</em></div>
                                <div class="stat-label">Per Cubes Weight</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-val"><em>4+</em></div>
                                <div class="stat-label">Standard Grades</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-val">MT+</div>
                                <div class="stat-label">Bulk Supply</div>
                            </div>
                        </div>

                        <div class="avail-row">
                            <span class="avail-dot">Available in Stock | </span>
                            <span class="avail-note">Min. order: 1 MT</span>
                        </div>
                    </div>
                </div>
            </div>
            <section class="features-section container ptb-50" aria-labelledby="features-heading">
                <div class="section-header">
                    <p class="section-eyebrow">Why Our Cubes</p>
                    <h2 class="section-title" id="features-heading">Precision Aluminium Cubes for Industrial Performance</h2>
                    <p class="section-sub">Our manufacturing process prioritises composition consistency, surface cleanliness, and dimensional accuracy. The three properties that matter most to foundry and die-casting operators using aluminium cubes.</p>
                </div>
                <div class="features-grid">
                    <div class="feature-card" data-anim data-delay="1">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                        </div>
                        <div class="feature-title">Consistent Alloy Composition</div>
                        <div class="feature-desc">Advanced spectrometric analysis at every melt ensures silicon, copper, and trace element levels remain within tight tolerances across each aluminium cube production batch.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="2">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" /></svg>
                        </div>
                        <div class="feature-title">High Purity Standards</div>
                        <div class="feature-desc">Our degassing and flux treatment process removes hydrogen, oxide inclusions, and other impurities to deliver clean, pore-free aluminium cubes with excellent melting efficiency.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="3">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" /></svg>
                        </div>
                        <div class="feature-title">Bulk Supply Capability</div>
                        <div class="feature-desc">With large-capacity furnaces and a consistent scrap sourcing network, we can reliably fulfil high-volume monthly aluminium cube supply contracts without compromising delivery timelines.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="4">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                        </div>
                        <div class="feature-title">Custom Grade Manufacturing</div>
                        <div class="feature-desc">Beyond standard grades, our team can formulate and manufacture custom aluminium cube alloys tailored to your exact specification requirements on request.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="5">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                        </div>
                        <div class="feature-title">Ahmedabad-Based Facility</div>
                        <div class="feature-desc">Strategically located at Shivadhin Industrial Park, Ahmedabad — offering convenient logistics access to Gujarat’s major auto and foundry clusters.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="6">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M12 3v1m0 16v1M4.22 4.22l.7.7m13.86 13.86l.7.7M1 12h2m18 0h2M4.22 19.78l.7-.7M18.64 5.36l.7-.7" /><circle cx="12" cy="12" r="4" /></svg>
                        </div>
                        <div class="feature-title">Eco-Responsible Process</div>
                        <div class="feature-desc">By recycling scrap aluminium rather than primary smelting, we reduce CO₂ output by up to 95% per tonne — supporting your ESG and sustainability goals.</div>
                    </div>
                </div>
            </section>
            <section class="specs-section container" id="specifications" aria-labelledby="specs-heading">
                <div class="section-header">
                    <p class="section-eyebrow">Datasheet</p>
                    <h2 class="section-title" id="specs-heading">Physical & chemical specifications</h2>
                </div>
                <div class="specs-layout">
                    <div class="spec-block" data-anim data-delay="1">
                        <div class="spec-block-head">Physical Properties</div>
                        <div class="spec-row">
                            <span class="spec-key">Form Factor</span>
                            <span class="spec-val">Standard Cubes</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Weight per Cubes</span>
                            <span class="spec-val highlight">As per requirement</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Density</span>
                            <span class="spec-val">2.65 – 2.70 g/cm³</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Melting Range</span>
                            <span class="spec-val">580°C – 660°C</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Surface Condition</span>
                            <span class="spec-val">Clean, Oxide-Free</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Packaging</span>
                            <span class="spec-val">Loose / bulk / customized packaging</span>
                        </div>
                    </div>
                    <div class="spec-block" data-anim data-delay="2">
                        <div class="spec-block-head">Supply & Commercial</div>
                        <div class="spec-row">
                            <span class="spec-key">Minimum Order Quantity</span>
                            <span class="spec-val highlight">1 Metric Tonne</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Standard Supply Volume</span>
                            <span class="spec-val">1 MT – 100+ MT/month</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Dispatch Turnaround</span>
                            <span class="spec-val">24 – 48 hours</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Delivery Coverage</span>
                            <span class="spec-val">Pan-India (road & rail)</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Test Certificate</span>
                            <span class="spec-val">Available on Request</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Custom Grades</span>
                            <span class="spec-val">Yes — 24 hr feasibility check</span>
                        </div>
                    </div>
                </div>
            </section>
            <Cta />
        </div>
    );
};

export default AluminiumCubes;
